import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './template/header/header.component';
import { FooterComponent } from './template/footer/footer.component';
import { SideNavComponent } from './template/side-nav/side-nav.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardHeaderComponent } from './template/dashboard-header/dashboard-header.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { SuccessAccountCreatedComponent } from './modal/success-account-created/success-account-created.component';
import { TermAndInsuranceComponent } from './modal/term-and-insurance/term-and-insurance.component';
import { PrivacyPolicyComponent } from './modal/privacy-policy/privacy-policy.component';
import { EmailSentComponent } from './modal/email-sent/email-sent.component';
import { AddteamsModalComponent } from './modal/addteams-modal/addteams-modal.component';
import { ShareCodeAddTeamsComponent } from './modal/share-code-add-teams/share-code-add-teams.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmationDialogueComponent } from './modal/confirmation-dialogue/confirmation-dialogue.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { RouteValidationComponent } from './modal/route-validation/route-validation.component';
import { ErrorHandlingComponent } from './template/error-handling/error-handling.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { PlayersPaymentModule } from '../modules/dashboard/organization-dashboard/players-payment/players-payment.module';
import { CancelOrderDialogueComponent } from './modal/cancel-order/cancel-order-dialogue.component';
import { AddcardDetailsComponent } from './modal/addcard-details/addcard-details.component';
import { OrderSuccessDialogueComponent } from './modal/order-success/order-success-dialogue.component';
import { LazyLoadImageModule, LAZYLOAD_IMAGE_HOOKS, ScrollHooks } from 'ng-lazyload-image'; // <-- include ScrollHooks
import { NgxStripeModule } from "ngx-stripe";
import { PlayerDetailsDialogueComponent } from './modal/player-details/player-details-dialogue.component';
import { AddPlayerModalComponent } from './modal/add-player/add-player-modal.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ProductItemListComponent } from './modal/product-item-list/product-item-list.component';
import { ConfirmationCancelComponent } from './modal/confirmation-cancel/confirmation-cancel.component';
// import { PaymentDetailsComponent } from '../modules/payment-details/payment-details.component';


// import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
// import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';

import { AddEventPopupComponent } from 'src/app/shared/template/add-event-popup/add-event-popup.component';
import { SelectRestaurantComponent } from 'src/app/shared/template/select-restaurant/select-restaurant.component';
import { ViewDetailsComponent } from 'src/app/shared/template/view-details/view-details.component';
import { ViewMenuDetailsComponent } from 'src/app/shared/template/view-menu-details/view-menu-details.component';
import { SelectDeliveryMethodComponent } from 'src/app/shared/template/select-delivery-method/select-delivery-method.component';
import { MatTimepickerModule } from 'mat-timepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PlayerOrdersCardComponent } from './modal/player-orders-card/player-orders-card';
import { PlayerOrdersDetailCardComponent } from './modal/player-orders-detail-card/player-orders-detail-card';
import { TableComponent } from './table/table.component';
import { ChangeEmailDialogComponent } from './modal/change-email-dialog/change-email-dialog.component';


const angMaterialLib = [
  MatListModule,
  MatButtonModule,
  MatCardModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatRadioModule,
  MatSidenavModule,
  MatFormFieldModule,
  MatMenuModule,
  MatTooltipModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatToolbarModule,
  MatAutocompleteModule,
  MatTimepickerModule,
  MatCheckboxModule
]

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SideNavComponent,
    DashboardHeaderComponent,
    SuccessAccountCreatedComponent,
    TermAndInsuranceComponent,
    PrivacyPolicyComponent,
    EmailSentComponent,
    AddteamsModalComponent,
    ShareCodeAddTeamsComponent,
    ConfirmationDialogueComponent,
    RouteValidationComponent,
    ErrorHandlingComponent,
    CancelOrderDialogueComponent,
    AddcardDetailsComponent,
    OrderSuccessDialogueComponent,
    PlayerDetailsDialogueComponent,
    AddPlayerModalComponent,
    ProductItemListComponent,
    ConfirmationCancelComponent,
    // PaymentDetailsComponent
    AddEventPopupComponent,
    SelectRestaurantComponent,
    ViewDetailsComponent,
    ViewMenuDetailsComponent,
    SelectDeliveryMethodComponent,
    PlayerOrdersCardComponent,
    PlayerOrdersDetailCardComponent,
    TableComponent,
    ChangeEmailDialogComponent
  ],
  exports: [
    HeaderComponent,
    RouteValidationComponent,
    FooterComponent,
    SideNavComponent,
    RouterModule,
    DashboardHeaderComponent,
    SuccessAccountCreatedComponent,
    TermAndInsuranceComponent,
    PrivacyPolicyComponent,
    EmailSentComponent,
    AddteamsModalComponent,
    AddcardDetailsComponent,
    ShareCodeAddTeamsComponent,
    ConfirmationDialogueComponent,
    CancelOrderDialogueComponent,
    ImageCropperModule,
    FormsModule,
    ReactiveFormsModule,
    PlayersPaymentModule,
    OrderSuccessDialogueComponent,
    ProductItemListComponent,
    ConfirmationCancelComponent,
    ...angMaterialLib,
    AddEventPopupComponent,
    SelectRestaurantComponent,
    ViewDetailsComponent,
    ViewMenuDetailsComponent,
    SelectDeliveryMethodComponent,
    PlayerOrdersCardComponent,
    PlayerOrdersDetailCardComponent,
    TableComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ImageCropperModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    PlayersPaymentModule,
    LazyLoadImageModule,
    ...angMaterialLib,
    NgHttpLoaderModule.forRoot(),
    NgxStripeModule.forRoot(
      // "pk_live_51Mwn3PF6k8u4g0kS8U3F1BZZIHblly6KtVP0t6REcMet7QsvPs6ZUs2MMuhZNbSAwz8YzAUlSv5OGu81VlQNUp4u00MBnKvE4H" // live
      "pk_test_51Rfo41PLIPq0nHQwiNsG6dmzxeenbE8jfMHq44mtbzpIx6BDf4Z4skUZHlQbC7iotk5tSgGb2DnMeh7pXicbQo2T004oIuB8Gl"
    ),
  ],
  providers: [{ provide: LAZYLOAD_IMAGE_HOOKS, useClass: ScrollHooks }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
